"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts_1 = require("./consts");
/**
 * Sorts nodes to the slots.
 */
function nodesToSlots(nodes) {
    var result = {};
    function push(key, node) {
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(node);
    }
    nodes.forEach(function (n) {
        if (n instanceof Element) {
            if (n.hasAttribute('slot')) {
                push(n.getAttribute('slot'), n);
            }
            else {
                push(consts_1.UNNAMED_SLOT_KEY, n);
            }
        }
        else if (n.nodeType === 1 || n.nodeType === 3) {
            push(consts_1.UNNAMED_SLOT_KEY, n);
        }
    });
    return result;
}
exports.nodesToSlots = nodesToSlots;
